import GeneralPolicyView from "../../policies/views/GeneralPolicyView";
import "./home.scss";

const GeneralPolicy = () => {
    return <div className="ph-15">
        <div className="home-page-body">
            <h1 className="pb-20">General Policy</h1>
            <h3 className="pb-20">Effective as of January 2024</h3>
            <div className="policy">
                <GeneralPolicyView />
            </div>
        </div>
    </div>
};

export default GeneralPolicy;